import { render, staticRenderFns } from "./Rotation.vue?vue&type=template&id=f4dccc8c"
import script from "./Rotation.vue?vue&type=script&lang=js"
export * from "./Rotation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports